module.exports = __webpack_public_path__ + "static/media/image-graph.17690756.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep5/image-graph.png
 ** module id = 226
 ** module chunks = 0
 **/